import { type Key } from 'react-aria-components';
import { Button, DropdownSelector } from '@repo/design-system-kit';
import { IconTrashOutlined } from '@repo/monochrome-icons';
import type { OperatorOption } from '../../../types/filters';
import styles from './filters-list-header.module.css';

interface FiltersListHeaderProps {
  label: string;
  operator?: OperatorOption;
  operators?: OperatorOption[];
  onOperatorChange?: (operator: Key) => void;
  onDelete?: () => void;
}

export function FiltersListHeader({
  label,
  operator,
  operators,
  onOperatorChange,
  onDelete,
}: FiltersListHeaderProps) {
  return (
    <div className={styles.container}>
      <span>{label}</span>
      {operators && operators.length > 1 && onOperatorChange ? (
        <DropdownSelector
          buttonSize="sm"
          items={operators.map(op => ({ ...op, key: op.displayKey ?? op.key }))}
          onSelectionChange={onOperatorChange}
          selectedKey={operator?.displayKey ?? operator?.key}
        />
      ) : null}
      {onDelete ? (
        <Button
          className={styles.deleteButton}
          iconOnly
          onPress={onDelete}
          size="small"
          variant="tertiary"
        >
          <IconTrashOutlined aria-hidden="true" />
        </Button>
      ) : null}
    </div>
  );
}
